export class Customer {
    key: string;
    description: string;
    amount: number;
    test: number;
    transcationType: string;
    active = true;
}
